module.exports = __webpack_public_path__ + "img/ws4.36e328a0.jpg";